import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Auth, Authenticate } from "./screens/Auth";
import { useAuth } from "./AuthContext";
import Tabview from "./components/Tabview";

import PrivacyPolicy from "./components/privacy-policy";
import TermsOfService from "./components/terms-of-service";
import DeleteAccount from "./screens/DeleteAccount";
import Support from "./screens/Support";

import style from "./App.module.css";

function App() {
    const { user } = useAuth();

    useEffect(() => {
        const handleFocus = (event: FocusEvent) => {
            const target = event.target;
            if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) {
                target.scrollIntoView({ block: "nearest" });
            }
        };

        document.addEventListener("focusin", handleFocus);
        return () => document.removeEventListener("focusin", handleFocus);
    }, []);

    return (
        <Router>
            <Routes>
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/support" element={<Support />} />
                <Route path="/delete" element={<DeleteAccount />} />
                <Route path="/auth/success" element={<Authenticate />} />
                <Route
                    path="*"
                    element={
                        <div className={style["container"]}>
                            <div className={style["wrapper--notice"]}>
                                <div></div>
                            </div>
                            <div className={style["wrapper--app"]}>
                                {!user ? <Auth /> : <Tabview></Tabview>}
                            </div>
                        </div>
                    }
                />
            </Routes>
        </Router>
    );
}

export default App;
